import dayjs from "dayjs";
import React, { useCallback, useContext } from "react";

import { DATE_FORMAT } from "../constants";
import DatepickerContext from "../contexts/DatepickerContext";

import { PrimaryButton, SecondaryButton } from "./utils";

const Footer: React.FC = () => {
    // Contexts
    const { hideDatepicker, changeDatepickerValue, classNames, changeInputText } =
        useContext(DatepickerContext);

    // Functions
    const getClassName = useCallback(() => {
        if (typeof classNames !== "undefined" && typeof classNames?.footer === "function") {
            return classNames.footer();
        }

        return "flex items-center justify-end pb-2.5 pt-3 border-t border-gray-300 dark:border-gray-700";
    }, [classNames]);

    return (
        <div className={getClassName()}>
            <div className="w-full flex items-center justify-between space-x-3">
                <PrimaryButton
                    onClick={() => {
                        changeDatepickerValue({
                            startDate: dayjs().subtract(30, "d").format(DATE_FORMAT),
                            endDate: dayjs().format(DATE_FORMAT)
                        });
                        hideDatepicker();
                    }}
                >
                    <>Today</>
                </PrimaryButton>
                <SecondaryButton
                    onClick={() => {
                        changeInputText("");
                        hideDatepicker();
                    }}
                >
                    <>Clear</>
                </SecondaryButton>
            </div>
        </div>
    );
};

export default Footer;
